/******************************************************************************
 * Copyright (c) 2016 - 2024.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2024-08-15                                                        *
 ******************************************************************************/
import storeGenerator from '../../utils/store-generator'
const ConfigurationCategoryAssignmentsStore = storeGenerator('/v2/configuration_category_assignments');
export default ConfigurationCategoryAssignmentsStore;
